var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dialog-wrapper" },
    [
      _c("ValidationProvider", {
        ref: "provider",
        attrs: { rules: { required: _vm.required }, slim: "" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var errors = ref.errors
              var failedRules = ref.failedRules
              return [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.value,
                      expression: "value"
                    }
                  ],
                  staticClass: "d-none",
                  attrs: {
                    "aria-hidden": "true",
                    "aria-label": "hidden field for validation"
                  },
                  domProps: { value: _vm.value },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.value = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                !_vm.inTable
                  ? _c(
                      "div",
                      { staticClass: "form-group row mt-3 list-row" },
                      [
                        _c("plain-text-control", {
                          staticClass: "col-xs-12 col-sm-5 col-form-label",
                          attrs: { required: _vm.required, title: _vm.title }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-xs-12 col-sm-7 form-row-content"
                          },
                          [
                            _c("div", { staticClass: "dialog-selections" }, [
                              !_vm.isReadOnly
                                ? _c("span", { staticClass: "inline-title" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("Selection.Selected")) + ":"
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("span", { staticClass: "preformatted" }, [
                                _vm.hasErrors(failedRules) && !_vm.isReadOnly
                                  ? _c(
                                      "span",
                                      { staticClass: "warning-text" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fas fa-exclamation-triangle fa-lg icon textrow-icon"
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(_vm._s(_vm.selectedOptionsString))
                              ])
                            ]),
                            _vm._v(" "),
                            !_vm.isReadOnly
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-secondary",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        return _vm.showModal()
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t(_vm.buttonLabel)))]
                                )
                              : _vm._e()
                          ]
                        )
                      ],
                      1
                    )
                  : _c("div", [
                      _c("span", [_vm._v(_vm._s(_vm.selectedOptionsString))])
                    ]),
                _vm._v(" "),
                _c("check-box-list-dialog", {
                  attrs: {
                    id: _vm.modalId,
                    title: _vm.title,
                    options: _vm.options,
                    noOptionsString: _vm.noOptionsString
                  },
                  model: {
                    value: _vm.selectedValues,
                    callback: function($$v) {
                      _vm.selectedValues = $$v
                    },
                    expression: "selectedValues"
                  }
                })
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }